import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { ChevronLeftIcon } from '@/src/components/icon/stroke/ChevronLeftIcon';
import { ChevronRightIcon } from '@/src/components/icon/stroke/ChevronRightIcon';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';

export const flowTimeClock: Components<Theme>['MuiTimeClock'] = {
  defaultProps: {
    slots: {
      leftArrowIcon: ChevronLeftIcon,
      rightArrowIcon: ChevronRightIcon,
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiClock-pin, & .MuiClockPointer-root, & .MuiClockPointer-thumb': {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
        borderColor: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
      },
      '& .MuiClockNumber-root': {
        '&.Mui-selected': {
          color: theme.palette.background.primary,
        },
      },
      // focus effect
      '& .MuiClock-clock:has(:focus-visible)': {
        // apply to pin in the middle if we don't have thumb yet
        '&:not(:has(.MuiClockPointer-thumb)) .MuiClock-pin': {
          ...getFocusRingStyle(theme, false, 4, ''),
        },
        // apply to thumb
        '& .MuiClockPointer-thumb': {
          ...getFocusRingStyle(theme, false, 16, ''),
        },
      },
    }),
    arrowSwitcher: {
      // hide by default, time buttons can be used instead
      display: 'none',
      // extra space for focus ring
      padding: '4px',
      // move below clock
      position: 'static',
      justifyContent: 'center',
    },
  },
};
